import React, { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { PasswordInput } from "@/components/PasswordInput";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export function ChangePasswordModal({ open, onOpenChange }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password updated");
      setCurrent(""); setNext(""); onOpenChange(false);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="glass-panel max-w-md space-y-4 rounded-2xl border-white/10 text-white">
        <DialogTitle className="font-display text-xl">Change password</DialogTitle>
        <div>
          <Label className="text-zinc-400">Current password</Label>
          <PasswordInput testId="current-password" value={current} onChange={(e) => setCurrent(e.target.value)}
            className="mt-1.5 rounded-sm border-white/10 bg-black" placeholder="Current password" />
        </div>
        <div>
          <Label className="text-zinc-400">New password</Label>
          <PasswordInput testId="new-password" value={next} onChange={(e) => setNext(e.target.value)}
            className="mt-1.5 rounded-sm border-white/10 bg-black" placeholder="At least 6 characters" />
        </div>
        <Button data-testid="change-password-submit" onClick={submit} disabled={saving || !current || next.length < 6}
          className="w-full rounded-full bg-primary text-white hover:bg-primary/90">
          {saving && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Update password
        </Button>
      </DialogContent>
    </Dialog>
  );
}
